import React from 'react';

const RadioInput = ({ id, label, options, register, name, onChange}) => {
    return (
        <div className="radio-input-container">
            <label>{label}</label>
            <div className="radio-group">
                {options.map((option, index) => (
                    <label key={index}>
                        <input
                            type="radio"
                            id={`${id}-${option.value}`}
                            name={name}
                            value={option.value}
                            {...register(name)}
                            onChange={onChange} // Aquí se asegura de pasar onChange
                        />
                        {option.label}
                    </label>
                ))}
            </div>
        </div>
    );
};

export default RadioInput;
